import React, { useCallback } from 'react';
import { AutoSaveBlockerModal } from './styles';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { CONTEXT_KEYS, useArtboardContext } from '../../context/complexArtboardContext';
import { COMPLEX_DESIGN_TOOLBAR } from './translationValues';

const NAMESPACES = ['COMPLEX_DESIGN_TOOLBAR'];

const AutoSaveBlocker = () => {
  const blockDesignSelector = useCallback(store => store[CONTEXT_KEYS.BLOCK_DESIGN], []);
  const [blockDesign] = useArtboardContext(
    blockDesignSelector,
    `ComplexArtboard`,
  );

  const { t } = useTranslation(NAMESPACES);

  if (blockDesign === undefined) {
    return <div />
  }

  return (
    <AutoSaveBlockerModal
      width="600px"
      centered
      closable={false}
      visible={true}
      footer={[
        <div className="footer">
          <Button
            label={'Contact Support'}
            large={true}
            className={'cancel-button'}
            onClick={() => {
              window.open('mailto:support@perfectdoc.studio');
            }}
          >
            {'Contact Support'}
          </Button>
        </div>,
      ]}
    >
      <p style={{ textAlign: 'center' }}>
        {t(COMPLEX_DESIGN_TOOLBAR.BLOCK_DESIGN_MODAL.key, COMPLEX_DESIGN_TOOLBAR.BLOCK_DESIGN_MODAL.value) + blockDesign.code}
      </p>
    </AutoSaveBlockerModal>
  );
};

export default AutoSaveBlocker;
